import { Button, Modal } from '@shared/widgets';

interface ErrorLoginModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ErrorLoginModal = (props: ErrorLoginModalProps) => {
  return (
    <Modal title='Incorrect Login Details' isOpen={props.isOpen} onClose={props.onClose}>
      <p className='max-md:text-[#4c4c4c80]'>
        You entered the wrong login details more than three times and your account is now temporarily locked. Please contact us for assistance or
        recover your password.
      </p>
      <div className='mt-4 mb-8 max-md:mx-6 max-md:mt-4 max-md:rounded-lg max-md:bg-[#d7c29a1a] max-md:p-2'>
        <p className='text-black'>24-hour phone support:</p>
        <p className='text-black'>+44-203-151-7000 / +800-800-00-700</p>
      </div>
      <Button className='mx-auto w-[159px] max-md:w-full' onClick={props.onClose}>
        Ok
      </Button>
    </Modal>
  );
};
